"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardComponentAnswers = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _addressAutocomplete = _interopRequireWildcard(require("./addressAutocomplete"));

var _age = _interopRequireWildcard(require("./age"));

var _checkbox = _interopRequireWildcard(require("./checkbox"));

var _date = _interopRequireDefault(require("./date"));

var _datetime = _interopRequireWildcard(require("./datetime"));

var _dob = _interopRequireWildcard(require("./dob"));

var _emailConfirm = _interopRequireDefault(require("./emailConfirm"));

var _english = _interopRequireWildcard(require("./english"));

var _ethnicity = _interopRequireWildcard(require("./ethnicity"));

var _ESS = _interopRequireWildcard(require("./ESS"));

var _fieldContainer = _interopRequireDefault(require("./fieldContainer"));

var _fileUpload = _interopRequireWildcard(require("./fileUpload"));

var _GAD = _interopRequireWildcard(require("./GAD7"));

var _gender = _interopRequireWildcard(require("./gender"));

var _maskCustom = _interopRequireWildcard(require("./maskCustom"));

var _number = require("./number");

var _PHQ = _interopRequireWildcard(require("./PHQ9"));

var _pregnancy = _interopRequireWildcard(require("./pregnancy"));

var _rangeSlider = _interopRequireDefault(require("./rangeSlider"));

var _selectNumberRange = _interopRequireDefault(require("./selectNumberRange"));

var _time = _interopRequireDefault(require("./time"));

var _selectAdvanced = _interopRequireDefault(require("./selectAdvanced"));

var _sex = _interopRequireWildcard(require("./sex"));

var _radio = _interopRequireDefault(require("./radio"));

var _usResident = _interopRequireWildcard(require("./usResident"));

var _pin = _interopRequireWildcard(require("./pin"));

var _default = {
  address: {
    component: _addressAutocomplete["default"],
    validations: _addressAutocomplete.validations
  },
  age: {
    component: _age["default"],
    answers: _age.answers
  },
  checkbox: {
    component: _checkbox["default"],
    validations: _checkbox.validations
  },
  checkboxgroupwithnone: {
    component: _checkbox["default"],
    validations: _checkbox.validations
  },
  date_picker: {
    component: function component(_ref) {
      var input = _ref.input,
          rest = (0, _objectWithoutProperties2["default"])(_ref, ["input"]);
      return /*#__PURE__*/_react["default"].createElement(_date["default"], (0, _extends2["default"])({}, rest, input));
    }
  },
  datetime: {
    component: _datetime["default"],
    validations: _datetime.validations
  },
  date_of_birth: {
    component: _dob["default"],
    validations: _dob.validations
  },
  email_confirm: {
    field: _emailConfirm["default"]
  },
  english: {
    component: _english["default"],
    answers: _english.answers
  },
  ethnicity: {
    component: _ethnicity["default"],
    answers: _ethnicity.answers
  },
  ess: {
    component: _ESS["default"],
    validations: _ESS.validations
  },
  field_container: {
    component: _fieldContainer["default"]
  },
  file_uploader: {
    component: _fileUpload["default"],
    validations: _fileUpload.validations
  },
  gad7: {
    component: _GAD["default"],
    validations: _GAD.validations
  },
  gender: {
    component: _gender["default"],
    answers: _gender.answers
  },
  mask_custom: {
    component: _maskCustom["default"],
    validations: _maskCustom.validations
  },
  number: {
    component: _number.NumberInput,
    validations: _number.validations
  },
  phq9: {
    component: _PHQ["default"],
    validations: _PHQ.validations
  },
  pregnancy: {
    component: _pregnancy["default"],
    answers: _pregnancy.answers
  },
  radioinput: {
    component: _radio["default"]
  },
  range_horizontal: {
    component: _rangeSlider["default"]
  },
  'select-number-range': {
    field: _selectNumberRange["default"]
  },
  'time (24-hour clock)': {
    component: _time["default"]
  },
  pin: {
    component: _pin["default"],
    validations: _pin.validations
  },
  selectadvanced: {
    component: _selectAdvanced["default"]
  },
  sex: {
    component: _sex["default"],
    answers: _sex.answers
  },
  us_resident: {
    component: _usResident["default"],
    answers: _usResident.answers
  }
};
exports["default"] = _default;
var StandardComponentAnswers = {};
exports.StandardComponentAnswers = StandardComponentAnswers;